export default "__VITE_ASSET__67907847__"